const isLocalhost = Boolean(
    window.location.hostname === 'localhost'
  );

var redirectSignIn = "http://localhost:3000";
var redirectSignOut = "http://localhost:3000";

if (!isLocalhost) {
    redirectSignIn = 'https://nfc-manager.eptarefrigeration.com';
    redirectSignOut = 'https://nfc-manager.eptarefrigeration.com';
  }

const customConfig = {
    "oauth": {
        "domain": "nfc-tagmanager-userpool-prod.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": redirectSignIn,
        "redirectSignOut": redirectSignOut,
        "responseType": "code"
    },
};


export default customConfig;